
const times = [
    { name: '년', milliSeconds: 60 * 60 * 24 * 365 },
    { name: '개월', milliSeconds: 60 * 60 * 24 * 30 },
    { name: '일', milliSeconds: 60 * 60 * 24 },
    { name: '시간', milliSeconds: 60 * 60 },
    { name: '분', milliSeconds: 60 },
];


export function TimerLeft(date) {
    const start = new Date();
    const end = new Date(date);

    const diff = (end - start) / 1000;

    for (const value of times) {
        const betweenTime = Math.floor(diff / value.milliSeconds);

        if (betweenTime > 0) {
            return {open: true, txt: `${betweenTime}${value.name}`};
        }
    }
    return {open: false, txt: '만료됨'};
}

export function TimerAgo(date) {
    const start = new Date(date);
    const end = new Date();

    const diff = (end - start) / 1000;

    for (const value of times) {
        const betweenTime = Math.floor(diff / value.milliSeconds);

        if (betweenTime > 0) {
            return `${betweenTime}${value.name} 전`;
        }
    }
    return '방금 전';
}